import { buildIncludeCompletions } from "./include.js";
import { buildLabelCompletions } from "./labels.js";
import { buildPackageCompletions } from "./packages.js";
import { buildSnippetCompletions } from "./snippets.js";
import { buildEnvironmentCompletions } from "./environments.js";
import { buildReferenceCompletions } from "./references.js";
import { buildClassCompletions } from "./classes.js";
import { buildBibliographyStyleCompletions } from "./bibliography-styles.js";
export const buildAllCompletions = (completions, context) => {
    buildSnippetCompletions(completions);
    buildEnvironmentCompletions(completions);
    buildClassCompletions(completions);
    buildBibliographyStyleCompletions(completions);
    buildIncludeCompletions(completions, context);
    buildReferenceCompletions(completions, context);
    buildLabelCompletions(completions, context);
    buildPackageCompletions(completions, context);
    return completions;
};
